/**
 * src/shell/ui/screens/TitleScreen.tsx — S0 标题/开场（设计稿 §2 Phase 0）。
 * 三步：标题 → 开场剧情（可跳过）→ Key 挂载（可稍后）。仅首启出现。
 */

import { useState } from 'react'
import { COPY } from '../../copy'
import { writeApiKey, type KeyMode } from '../../save/apikey'
import { pushToast } from '../../gm-client/toast'

export function TitleScreen({ onEnter }: { onEnter: () => void }) {
  const [step, setStep] = useState<'title' | 'intro' | 'key'>('title')
  const [page, setPage] = useState(0)
  const [keyInput, setKeyInput] = useState('')
  const [mode, setMode] = useState<KeyMode>('local')
  const C = COPY.title

  if (step === 'title') {
    return (
      <div className="screen title-screen">
        <h1 className="game-logo">{C.logo}</h1>
        <button className="btn btn-primary" type="button" onClick={() => setStep('intro')}>
          {C.start}
        </button>
      </div>
    )
  }

  if (step === 'intro') {
    // deck §三呈现规格：两屏（intro[0]/intro[1]），「继续」翻页、末屏后进 Key，「跳过」直达
    const lines = C.intro[page].split('\n\n')
    const isLast = page >= C.intro.length - 1
    return (
      <div className="screen intro-screen">
        <div className="panel">
          {lines.map((line, i) => (
            <p key={i}>{line}</p>
          ))}
          <div className="btn-row">
            <button
              className="btn btn-primary"
              type="button"
              onClick={() => (isLast ? setStep('key') : setPage(page + 1))}
            >
              {C.introContinue}
            </button>
            <button className="btn" type="button" onClick={() => setStep('key')}>
              {C.introSkip}
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="screen key-screen">
      <div className="panel">
        <h2>{C.keyTitle}</h2>
        <p className="dim">{C.keyHint}</p>
        <input
          className="text-input"
          type="password"
          value={keyInput}
          onChange={(e) => setKeyInput(e.target.value)}
          placeholder="sk-..."
          autoComplete="off"
        />
        <label className="radio-row">
          <input type="radio" checked={mode === 'local'} onChange={() => setMode('local')} />
          {C.keyModeLocal}
        </label>
        <label className="radio-row">
          <input type="radio" checked={mode === 'session'} onChange={() => setMode('session')} />
          {C.keyModeSession}
        </label>
        <div className="btn-row">
          <button
            className="btn btn-primary"
            type="button"
            disabled={!keyInput.trim()}
            onClick={() => {
              writeApiKey(keyInput, mode)
              pushToast(C.keySaved)
              onEnter()
            }}
          >
            {C.keyEnter}
          </button>
          <button className="btn" type="button" onClick={onEnter}>
            {C.keyLater}
          </button>
        </div>
      </div>
    </div>
  )
}
